import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CommonButton } from "@/components/ui/common-button";
import { Eye, EyeOff } from 'lucide-react';

const OtpDetailsDialog = ({ open, onOpenChange, tripDetails }) => {
  const [showLoginOtp, setShowLoginOtp] = useState(false);
  const [showDeliveryOtp, setShowDeliveryOtp] = useState(false);
  const [showStartOtp, setShowStartOtp] = useState(false);

  if (!tripDetails) return null;

  const getStartOtp = (trip) => {
 
    if (trip.start_trip_otp) {
      return trip.start_trip_otp;
    }

    if (trip.start_otp) {
      return trip.start_otp;
    }
    if (trip.otp_info && trip.otp_info.start_trip_otp) {
      return trip.otp_info.start_trip_otp;
    }
    return 'N/A';
  };

  const getDeliveryOtp = (trip) => {

    if (trip.end_trip_otp) {
      return trip.end_trip_otp;
    }

    if (trip.delivery_otp) {
      return trip.delivery_otp;
    }
    if (trip.otp_info && trip.otp_info.end_trip_otp) {
      return trip.otp_info.end_trip_otp;
    }
    return 'N/A';
  };

  const getLoginOtp = (trip) => {
 
    if (trip.driver_login_otp) {
      return trip.driver_login_otp;
    }

    if (trip.otp_info && trip.otp_info.driver_login_otp) {
      return trip.otp_info.driver_login_otp;
    }
    return 'N/A';
  };

  const hasValidOtps = (trip) => {
    const startOtp = getStartOtp(trip);
    const endOtp = getDeliveryOtp(trip);
    const loginOtp = getLoginOtp(trip);
    
    return startOtp !== 'N/A' || endOtp !== 'N/A' || loginOtp !== 'N/A';
  };

  const CustomDashboardCard = ({ name, count, showOtpButton, onShowOtp, otpVisible }) => (
    <div className="border border-border p-0.5 rounded-[16px] bg-card w-full transition-all transform" 
         style={{boxShadow: '0px 2px 10px 0px hsl(var(--border) / 0.1)'}}>
      <div className="border border-border px-2 py-2 rounded-[16px] bg-background">
        <div className="space-y-1">
          <div className="text-xs font-medium text-muted-foreground flex justify-between items-center">
            {name}
            {showOtpButton && count !== 'N/A' && (
              <CommonButton 
                variant="outline" 
                size="sm" 
                onClick={onShowOtp}
                icon={otpVisible ? EyeOff : Eye}
                className="h-6 text-xs"
              >
                {otpVisible ? 'Hide' : 'Show'}
              </CommonButton>
            )}
          </div>
          <div className="text-xs font-normal">
            {count !== 'N/A' ? count : (
              <span className="text-muted-foreground italic">Not generated yet</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>OTP Details</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          {!hasValidOtps(tripDetails) ? (
            <div className="text-center py-4 text-muted-foreground">
              <p>No OTPs have been generated for this trip yet.</p>
              <p className="text-sm mt-2">OTPs are typically generated when the trip is started or completed.</p>
            </div>
          ) : (
            <>
              <CustomDashboardCard 
                name="Login OTP" 
                count={showLoginOtp ? getLoginOtp(tripDetails) : '****'}
                showOtpButton={getLoginOtp(tripDetails) !== 'N/A'}
                onShowOtp={() => setShowLoginOtp(!showLoginOtp)}
                otpVisible={showLoginOtp}
              />
              <CustomDashboardCard 
                name="Start Trip OTP" 
                count={showStartOtp ? getStartOtp(tripDetails) : '****'}
                showOtpButton={getStartOtp(tripDetails) !== 'N/A'}
                onShowOtp={() => setShowStartOtp(!showStartOtp)}
                otpVisible={showStartOtp}
              />
              <CustomDashboardCard 
                name="End Trip OTP" 
                count={showDeliveryOtp ? getDeliveryOtp(tripDetails) : '****'}
                showOtpButton={getDeliveryOtp(tripDetails) !== 'N/A'}
                onShowOtp={() => setShowDeliveryOtp(!showDeliveryOtp)}
                otpVisible={showDeliveryOtp}
              />
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OtpDetailsDialog;